import * as Sentry from "@sentry/vue"

// Initialisation de Sentry pour une instance de Vue.
// Fonction à appeler le plus tôt possible dans le cycle de vie de l'app,
// c'est-à-dire juste après le createApp() et avant les app.use().
export const initialiserSentryPourAppVue = (app, router) => {
  if (import.meta.env.VITE_DEPLOIEMENT === 'dev') return // Pas de Sentry en dev

  const integrations = []

  if (router) {
    integrations.push(
      Sentry.browserTracingIntegration({ router })
    )
  }

  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations,
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.01,
    environment: import.meta.env.VITE_DEPLOIEMENT,
  })
}
